import React, { useState, useEffect, useCallback } from 'react';
import { Button } from './ui/button';
import { heroData, contactInfo } from '../mockData';
import { EditableText, EditableImage } from './EditableComponents';
import { useEditMode } from '../contexts/EditModeContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Hero = () => {
  const { isEditMode } = useEditMode();
  const [localHeroData, setLocalHeroData] = useState(heroData);
  const [heroImageUrl, setHeroImageUrl] = useState("https://images.unsplash.com/photo-1601024445121-e5b82f020549?w=800&q=80");

  const loadSettings = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      if (response.data) {
        setLocalHeroData({
          title: response.data.hero_title,
          subtitle: response.data.hero_subtitle,
          description: response.data.hero_description,
          location: "Reggio nell'Emilia"
        });
        if (response.data.hero_image_url) {
          setHeroImageUrl(response.data.hero_image_url);
        }
      }
    } catch (error) {
      // Failed to load settings - use defaults
      setLocalHeroData(heroData);
    }
  }, []);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const saveToBackend = async (field, value) => {
    try {
      const updateData = {};
      if (field === 'title') {
        updateData.hero_title = value;
        setLocalHeroData({...localHeroData, title: value});
      }
      if (field === 'subtitle') {
        updateData.hero_subtitle = value;
        setLocalHeroData({...localHeroData, subtitle: value});
      }
      if (field === 'description') {
        updateData.hero_description = value;
        setLocalHeroData({...localHeroData, description: value});
      }
      if (field === 'image') {
        updateData.hero_image_url = value;
        setHeroImageUrl(value);
      }
      
      await axios.put(`${API}/settings`, updateData);
    } catch (error) {
      console.error('Error saving:', error);
    }
  };

  const HeroTitle = () => {
    if (isEditMode) {
      return (
        <EditableText
          value={localHeroData.title}
          onSave={(val) => saveToBackend('title', val)}
          label="Titolo"
        />
      );
    }
    return <h1 className="hero-title">{localHeroData.title}</h1>;
  };

  const HeroSubtitle = () => {
    if (isEditMode) {
      return (
        <EditableText
          value={localHeroData.subtitle}
          onSave={(val) => saveToBackend('subtitle', val)}
          label="Sottotitolo"
        />
      );
    }
    return <p className="hero-subtitle">{localHeroData.subtitle}</p>;
  };

  const HeroDescription = () => {
    if (isEditMode) {
      return (
        <EditableText
          value={localHeroData.description}
          onSave={(val) => saveToBackend('description', val)}
          label="Descrizione"
          multiline
        />
      );
    }
    return <p className="hero-description">{localHeroData.description}</p>;
  };

  const HeroImage = () => {
    if (isEditMode) {
      return (
        <EditableImage
          src={heroImageUrl}
          alt="Tabaccheria N.16"
          onSave={(val) => saveToBackend('image', val)}
          label="Immagine Hero"
        />
      );
    }
    return (
      <div className="hero-image-wrapper">
        <img 
          src={heroImageUrl} 
          alt="Tabaccheria N.16"
          className="hero-img"
        />
        <div className="hero-overlay"></div>
      </div>
    );
  };

  return (
    <>
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <HeroTitle />
            <HeroSubtitle />
            <HeroDescription />

            <div className="hero-cta">
              <Button 
                size="lg" 
                className="cta-primary" 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Contattaci
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="cta-secondary" 
                onClick={() => document.getElementById('svapo')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Scopri Prodotti Svapo
              </Button>
            </div>
          </div>
          
          <div className="hero-image">
            <HeroImage />
          </div>
        </div>
      </section>
    </>
  );
};
